import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = articles.slice(0, 3);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 max-w-7xl mx-auto">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-600 mt-2">编辑精心挑选的优质内容</p>
        </div>
        <Link
          to="/category/all"
          className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {featured.map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all"
          >
            <div className="relative h-48 overflow-hidden">
              <img
                src={article.coverImage}
                alt={article.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3">
                <span className="bg-primary-500 text-white text-xs px-2 py-1 rounded-full">
                  精选
                </span>
              </div>
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line"></i> {article.publishedAt}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                </span>
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                {article.excerpt}
              </p>
              <div className="flex items-center gap-2 mt-3 flex-wrap">
                {article.tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-6 text-center sm:hidden">
        <Link
          to="/category/all"
          className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}